/* ui-kit.js — общие UI-примитивы сайта ФМГТО (классический скрипт, грузится до модулей).
   Уведомления: Notyf (MIT, github.com/caroso1222/notyf) вместо системного alert().
   window.fmgtoNotify(message, type?) — type: 'success' | 'error' | 'info' (по умолчанию определяется по тексту). */
(function () {
  var EMOJI = /^[\s☀-➿️‍\u{1F300}-\u{1FAFF}]+/u;
  var notyf = null;
  function ensure() {
    if (notyf || typeof window.Notyf !== 'function') return notyf;
    var mobile = window.matchMedia && window.matchMedia('(max-width: 720px)').matches;
    notyf = new window.Notyf({
      duration: 4500, dismissible: true, ripple: false,
      position: { x: mobile ? 'center' : 'right', y: 'top' },
      types: [
        { type: 'success', background: '#0f2a1f', className: 'fm-toast fm-toast-success', icon: false },
        { type: 'error', background: '#2a1215', className: 'fm-toast fm-toast-error', icon: false, duration: 6500 },
        { type: 'info', background: '#0b1628', className: 'fm-toast fm-toast-info', icon: false }
      ]
    });
    return notyf;
  }
  function detectType(raw) {
    if (/^\s*(⚠|❌|✗|✕|🚫|⛔)/.test(raw) || /(ошибк|не удалось|неверн|некорректн|введите|укажите|необходимо|недоступ|запрещ)/i.test(raw)) return 'error';
    if (/^\s*(✅|✓|✔|🎉|👍)/.test(raw) || /(сохранен|отправлен|готово|успешно|добавлен|опубликован|скопирован)/i.test(raw)) return 'success';
    return 'info';
  }
  window.fmgtoNotify = function (message, type) {
    var raw = String(message == null ? '' : message);
    var text = raw.replace(EMOJI, '').trim() || raw;
    var t = type || detectType(raw);
    var n = ensure();
    if (!n) { try { window.__nativeAlert(text); } catch (_) {} return; }
    n.open({ type: t, message: text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\n/g, '<br>') });
  };
  // Все alert() сайта (≈80 мест в модулях) показываются как уведомления, не блокируя страницу
  window.__nativeAlert = window.alert.bind(window);
  window.alert = function (message) { window.fmgtoNotify(message); };
})();
